WiseMetering.Collection.IntegrationLicenses = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.IntegrationLicense,
    url: '/integration_licenses'
});
